import { GridLocaleText } from "@mui/x-data-grid";
import { PropertyMetadata } from "../../api-models/response/DynamicProperty";
import { DataGridStorage } from "./DataGridStorage";
import { IssueSeverity } from "../../generated/SewerObjects";

export enum ColumnType {
  String = "string",
  Number = "number",
  Boolean = "boolean",
  DateTime = "dateTime",
  SingleSelect = "singleSelect",
}

export interface Column {
  key: string;
  name: string;
  order?: number;
  sortable?: boolean;
  filterable?: boolean;
  containsLink?: boolean;
  flex?: number;
  type?: ColumnType;
  formatString?: string;
  valueOptions?: Option[];
}

export interface Option {
  label: string;
  value: string;
}

export enum SortDirection {
  NotSorted = "not-sorted",
  Asc = "asc",
  Desc = "desc",
}

export interface UrlParams {
  [key: string]: string | number | boolean | undefined | null;
}

export interface DisplayValue {
  toDisplay: any;
  value?: any;
  id?: number;
  path?: string;
  onClick?: any;
  isDeleted?: boolean;
  hasIssues?: boolean;
  maxIssueSeverity?: IssueSeverity;
  hasMissingGeometry?: boolean;
  entityName?: string;
  metadata?: PropertyMetadata;
  className?: string;
  absolute?: boolean;
  child?: () => any;
}

export interface DisplayValues {
  [key: string]: DisplayValue;
}

export interface RowItemData {
  displayValues: DisplayValues;
  id: number;
  path?: string;
}

export interface IToolbarCustomButton {
  icon: any;
  textKey: string;
  callback: () => void;
  isDisabled?: boolean;
}

export interface IDataGrid {
  itemTypeKey: string;
  dataGridStorage: DataGridStorage;
  rowClickPath?: string;
  reloadOnRowClick?: boolean;
  conditionForRowClickAvailable?: string;
  hasDynamicRowClickPath?: boolean;
  hasDefaultColumnVisibility?: boolean;
  insideDialog?: boolean;
  singleSelection?: boolean;
  noSelection?: boolean;
  noResultsMessageKey?: string;
  withTopSpacing?: boolean;
  toolbarCustomButton?: IToolbarCustomButton;
  filterModelChangeCallback?: () => void;
  isOnSide?: boolean;
  isCollapsible?: boolean;
  isStatusDropdownTable?: boolean;
  customSelectAll?: boolean;
  customLocalizationMappings?: Partial<GridLocaleText>;
  hideTotalAmount?: boolean;
}
